import {useRef, useState} from 'react'
import {startOfDay} from 'date-fns'
import dateFnsGenerateConfig from 'rc-picker/lib/generate/dateFns'
import generatePicker from 'antd/es/date-picker/generatePicker'

import {DropdownIcon} from 'common/components'
import {formatDate} from 'common/helpers'
import {DATE_PATTERN} from 'common/constants'

export const AntdDatePicker = generatePicker<Date>(dateFnsGenerateConfig)

export const {RangePicker} = AntdDatePicker

export default function DatePicker({
  minDate,
  maxDate,
  disabledDates,
  disabledDate,
  ...props
}: any) {
  const [isOpen, setIsOpen] = useState(false)
  const todayRef = useRef(startOfDay(new Date()))

  const customDisabledDate = disabledDate
    ? disabledDate
    : (date: Date) =>
        ((!minDate) && (date < todayRef.current)) ||
        (maxDate && date > maxDate) ||
        (minDate && date < minDate) ||
        disabledDates
          ?.map((date: Date) => formatDate(date))
          .includes(formatDate(date))

  return (
    <AntdDatePicker
      format={isOpen ? DATE_PATTERN.pickerShort : DATE_PATTERN.pickerLong}
      mode="date"
      suffixIcon={<DropdownIcon />}
      showToday={false}
      placeholder={null}
      disabledDate={customDisabledDate}
      onOpenChange={setIsOpen}
      {...props}
    />
  )
}
